<h4 mat-dialog-title>{{ data.title }} </h4>
<div mat-dialog-content>
  <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
  <button mat-dialog-close mat-flat-button color="primary">
    {{ data.cancelText || ('LABEL.NO' | translate) }}
  </button>
  <button mat-flat-button color="primary" (click)="onConfirm()">
    {{ data.confirmText || ('LABEL.YES' | translate) }}
  </button>
</div>
